import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "Documents";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
    name,
    initialState,
    extraReducers: (builder) => {
        createExtraReducers(builder, extraActions);
    },
});

// exports

export const DocumentsActions = { ...slice.actions, ...extraActions };
export const DocumentsReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        LoadDocumentSearchDetails: [],
        DownloadFileFromPathResponses: [],
    };
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;


    return {
        getLoadDocumentSearch: getLoadDocumentSearch(),
        getDownloadFileFromPath: getDownloadFileFromPath()
    };


    function getLoadDocumentSearch() {
        return createAsyncThunk(
            `${name}/getLoadDocumentSearch`,
            async (objData) =>
                await fetchWrapper.post(`${baseUrl}/Kiosk/KioskPostMail/LoadKioskDocumentSearch`, objData)
        );
    }
    function getDownloadFileFromPath() {       

        return createAsyncThunk(
            `${name}/getDownloadFileFromPath`,
            async ({ folderPath, filename }, thunkAPI) => {
                try {
                    const blob = await fetchWrapper.get(
                        `${baseUrl}/kiosk/KioskS3Activity/DownloadFileFromPath?folderPath=${folderPath}&filename=${filename}`,
                        null,
                        { isFile: true }
                    );
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.onerror = reject;
                        reader.readAsDataURL(blob); // Output: data:application/pdf;base64,...
                    });
                } catch (error) {
                    console.error("Error:", error);
                    return thunkAPI.rejectWithValue(error.message || "Unexpected error");
                }
            }
        );
    }

}

function createExtraReducers(builder, actions) {
    builder
        .addCase(actions.getLoadDocumentSearch.pending, (state) => {
            //state.LoadDocumentSearchDetails = [];
        })
        .addCase(actions.getLoadDocumentSearch.fulfilled, (state, action) => {
            state.LoadDocumentSearchDetails = action.payload;
        })
        .addCase(actions.getLoadDocumentSearch.rejected, (state, action) => {
            state.LoadDocumentSearchDetails = { error: action.error };
        })
        .addCase(actions.getDownloadFileFromPath.pending, (state) => {
            state.DownloadFileFromPathResponses = [];
        })
        .addCase(actions.getDownloadFileFromPath.fulfilled, (state, action) => {
            state.DownloadFileFromPathResponses = action.payload;
        })
        .addCase(actions.getDownloadFileFromPath.rejected, (state, action) => {
            state.DownloadFileFromPathResponses = { error: action.error };
        });
}
